import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, of, tap} from "rxjs";
import {ApplicationSettings} from "../interfaces/settings.interface";
import {config} from "../../../config";

@Injectable({
    providedIn: 'root'
})
export class SettingService {
    private readonly http = inject(HttpClient);

    public get settings(): Observable<ApplicationSettings | null> {
        return this.http.get<ApplicationSettings>('/settings').pipe(
          tap(settings => {
            this.updateConfig(settings);
          }),
          catchError(() => of(null))
        );
    }

  private updateConfig(settings: ApplicationSettings) {
    if (settings['display.name']) config.companyName = settings['display.name'];
    if (settings['portal.name']) config.appName = settings['portal.name'];
    if (settings['portal.slogan']) config.companySlogan = settings['portal.slogan']!;
    if (settings['iban']) config.bank_account = settings['iban'];

    // Support settings
    if (settings['support.need-help.text']) config.support.needHelpText = settings['support.need-help.text'];
    if (settings['support.manual.url']) config.support.manual_url = settings['support.manual.url'];
    if (settings['portal.text.manual']) config.view.portal.text.manual = settings['portal.text.manual'];
    if (settings['view.portal.manual']) config.view.portal.manual = settings['view.portal.manual'] == '1';
    if (settings['view.portal.questions']) config.view.portal.questions = settings['view.portal.questions'] == '1';
    if (settings['view.portal.facebook']) config.view.portal.facebook = settings['view.portal.facebook'] == '1';
    if (settings['view.portal.whatsapp']) config.view.portal.whatsapp = settings['view.portal.whatsapp'] == '1';
    if (settings['view.portal.chat']) config.view.portal.chat = settings['view.portal.chat'] == '1';
    if (settings['view.portal.phone']) config.view.portal.phone = settings['view.portal.phone'] == '1';
    if (settings['support.contact.whatsapp']) config.support.contact.whatsapp = settings['support.contact.whatsapp'];
    if (settings['support.contact.whatsapp.url']) config.support.contact.whatsapp_url = settings['support.contact.whatsapp.url'];
    if (settings['support.contact.facebook']) config.support.contact.facebook = settings['support.contact.facebook'];
    if (settings['support.contact.chat']) config.support.contact.chat = settings['support.contact.chat'];
    if (settings['support.contact.url']) config.support.contact.url = settings['support.contact.url'];
    if (settings['phone']) config.support.contact.phone = settings['phone'];

    // Limits and Counts
    if (settings['tickets.text.min.character.count']) config.support.textMinCharacterCount = settings['tickets.text.min.character.count'];
    if (settings['tickets.text.max.character.count']) config.textMaxCharacterCount = settings['tickets.text.max.character.count'];
    if (settings['tickets.max.count.per.relation']) config.maxTicketsPerRelation = settings['tickets.max.count.per.relation'];
    if (settings['tickets.recent.count']) config.recentTicketsCount = settings['tickets.recent.count'];

    // External URLs
    if (settings['live-tv.url']) config.livetv_url = settings['live-tv.url'];
    if (settings['trustpilot.url']) config.trustpilot_url = settings['trustpilot.url'];
    if (settings['google-reviews.url']) config.google_reviews_url = settings['google-reviews.url'];
  }
}

